<template>
  <div>
    <v-menu
        bottom
        left
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
            dark
            icon
            v-bind="attrs"
            v-on="on"
            width="10"
        >
          <v-icon small>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>

      <v-list dense>
        <v-list-item
            v-for="(barAction, i) in value" :key="i"
            v-if="isShow(barAction)"
        >
          <v-list-item-avatar>
            <v-icon :color="barAction.icon_color" v-show="!isLoad(barAction)">{{ !!barAction.icon ? barAction.icon : 'mdi-circle-small'}}</v-icon>
            <v-progress-circular
                v-show="isLoad(barAction)"
                indeterminate
                size="16"
                width="1"
                color="blue-grey lighten-1"
                class="ml-1 mr-n2"
            >
            </v-progress-circular>
          </v-list-item-avatar>
          <v-list-item-title
              :color="barAction.color"
              @click="onAction(barAction)"
              :disabled='true'
          >
            {{ barAction.label }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
  <!--  <v-toolbar dense flat height="32">-->
  <!--    <slot name="left"></slot>-->
  <!--    <v-tooltip top v-for="barAction of value">-->
  <!--      <template v-slot:activator="{ on, attrs }">-->
  <!--        <v-spacer v-if="barAction.action_name === 'embedded_space'"></v-spacer>-->
  <!--        <v-btn-->
  <!--            v-if="isShow(barAction)"-->
  <!--            v-on="on"-->
  <!--            small-->
  <!--            elevation="2"-->
  <!--            :color="barAction.color"-->
  <!--            dense-->
  <!--            class="mx-1"-->
  <!--            @click="onAction(barAction)"-->
  <!--            :disabled="isDisabled(barAction) || isLoad(barAction)"-->
  <!--        >-->
  <!--          <v-icon :color="barAction.icon_color">{{ barAction.icon }}</v-icon>-->
  <!--          {{ barAction.label }}-->
  <!--          <v-progress-circular-->
  <!--              v-show="isLoad(barAction)"-->
  <!--              indeterminate-->
  <!--              size="16"-->
  <!--              width="1"-->
  <!--              color="blue-grey lighten-1"-->
  <!--              class="ml-1 mr-n2"-->
  <!--          >-->
  <!--          </v-progress-circular>-->
  <!--        </v-btn>-->
  <!--      </template>-->
  <!--      <span v-if="!!barAction.text">{{ barAction.text }}</span>-->
  <!--      <span v-else>{{ barAction.label }}</span>-->
  <!--    </v-tooltip>-->
  <!--    <slot name="right"></slot>-->
  <!--  </v-toolbar>-->
</template>

<script>

import {defineStore} from "pinia";
import {storeToRefs} from 'pinia'

export const useActionStore = function () {
  return defineStore('CommonBarMenu', {
        state: () => ({
              actionsUid: {},
              actionsCallReceive: {},
            }
        ),
      }
  )
}

export default {
  name: 'CommonBarMenu',
  inheritAttrs: false,
  props: {
    value: {default: null},
    disabled: {default: true},
    selectedItems: {
      default() {
        return []
      }
    },
    storeName: {default: 'CommonBarMenu'},
    isNew: {default: false},
    fetchAction: {default: null},
    modalDialog: {default: false},
  },

  components: {},

  computed: {},

  setup({storeName}) {
    // console.log('setup', storeName, uidItem, modalDialog)
    let state = useActionStore(storeName)()
    return {state}
  },

  methods: {
    onAction(barAction) {
      // console.log('Action event', barAction.action_name, barAction.action_uid)
      if (barAction.action_name.includes('embedded_')) {
        this.$emit(barAction.action_name)
        this.$emit('embedded_action', {actionName: barAction.action_name, actionUid: barAction.action_uid})
        return
      }
      if (barAction.action_name.includes('alternate_')) {
        this.state.actionsUid[barAction.action_uid] = {load: true}
        this.$emit('alternate_action', {actionName: barAction.action_name, actionUid: barAction.action_uid})
        return
      }
      this.$emit('action', {actionName: barAction.action_name, actionUid: barAction.action_uid})
      this.state.actionsUid[barAction.action_uid] = {load: true}
    },
    isShow(barAction) {
      // console.log('isShow', this.isNew)
      return barAction.action_name !== 'embedded_space' && (!barAction.only_modal || this.modalDialog)
    },
    isDisabled(barAction) {
      if (barAction.disabled)
        return true
      if (barAction.show_only_selected && this.selectedItems.length === 0)
        return true
      return false
    },
    isLoad(barAction) {
      let action_state = this.state.actionsUid[barAction.action_uid]
      if (!!action_state)
        return action_state.load
    },
  },

  async mounted() {
  },

  data() {
    return {}
  }
}
</script>

